export default __webpack_public_path__ + "static/media/ingfo.571fa8cb.jpg";